import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import AgeGate from "@/components/AgeGate";
import ConnectionGuard from "@/components/ConnectionGuard";
import Layout from "@/components/Layout";
import ProtectedRoute from "@/components/ProtectedRoute";
import Feed from "@/pages/Feed";
import Explore from "@/pages/Explore";
import MediaDetail from "@/pages/MediaDetail";
import Upload from "@/pages/Upload";
import Saved from "@/pages/Saved";
import ImportUrl from "@/pages/ImportUrl";
import Profile from "@/pages/Profile";
import Auth from "@/pages/Auth";
import Admin from "@/pages/Admin";
import Chat from "@/pages/Chat";
import Donate from "@/pages/Donate";
import DonateSuccess from "@/pages/DonateSuccess";
import AiSearch from "@/pages/AiSearch";
import Stories from "@/pages/Stories";
import StoryUpload from "@/pages/StoryUpload";
import StoryReader from "@/pages/StoryReader";
import StoryReview from "@/pages/StoryReview";
import ForYou from "@/pages/ForYou";
import Concepts from "@/pages/Concepts";
import ConceptPage from "@/pages/ConceptPage";
import About from "@/pages/About";
import Archive from "@/pages/Archive";
import Members from "@/pages/Members";
import OAuthCallback from "@/pages/OAuthCallback";

function Shell() {
  return (
    <Layout>
      <Routes>
        <Route path="/" element={<Feed />} />
        <Route path="/explore" element={<Explore />} />
        <Route path="/archive" element={<Archive />} />
        <Route path="/members" element={<Members />} />
        <Route path="/foryou" element={<ProtectedRoute><ForYou /></ProtectedRoute>} />
        <Route path="/concepts" element={<Concepts />} />
        <Route path="/c/:key" element={<ConceptPage />} />
        <Route path="/about" element={<About />} />
        <Route path="/discover" element={<AiSearch />} />
        <Route path="/stories" element={<Stories />} />
        <Route path="/stories/upload" element={<ProtectedRoute><StoryUpload /></ProtectedRoute>} />
        <Route path="/stories/:id" element={<StoryReader />} />
        <Route path="/admin/stories" element={<ProtectedRoute staffOnly><StoryReview /></ProtectedRoute>} />
        <Route path="/media/:id" element={<MediaDetail />} />        <Route path="/u/:username" element={<Profile />} />
        <Route path="/upload" element={<ProtectedRoute><Upload /></ProtectedRoute>} />
        <Route path="/saved" element={<ProtectedRoute><Saved /></ProtectedRoute>} />
        <Route path="/import" element={<ProtectedRoute><ImportUrl /></ProtectedRoute>} />
        <Route path="/import-x" element={<ProtectedRoute><ImportUrl /></ProtectedRoute>} />
        <Route path="/chat" element={<ProtectedRoute><Chat /></ProtectedRoute>} />
        <Route path="/donate" element={<Donate />} />
        <Route path="/donate/success" element={<DonateSuccess />} />
        <Route path="/chat/:id" element={<ProtectedRoute><Chat /></ProtectedRoute>} />
        <Route path="/admin" element={<ProtectedRoute staffOnly><Admin /></ProtectedRoute>} />
      </Routes>
    </Layout>
  );
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AgeGate />
        <ConnectionGuard />
        <Toaster theme="dark" position="bottom-right" toastOptions={{ style: { background: "#242526", border: "1px solid #393A3D", color: "#E4E6EB", borderRadius: 12 } }} />
        <Routes>
          <Route path="/login" element={<Auth mode="login" />} />
          <Route path="/register" element={<Auth mode="register" />} />
          <Route path="/forgot-password" element={<Auth mode="forgot" />} />
          <Route path="/reset-password" element={<Auth mode="reset" />} />
          <Route path="/verify-email" element={<Auth mode="verify" />} />
          <Route path="/auth/callback" element={<OAuthCallback />} />
          <Route path="/*" element={<Shell />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
